<template>
  <div id="app">
    <router-view />
    <notice-dialog ref="noticeDialog" footer @close="openDialog" />
  </div>
</template>

<script>
import NoticeDialog from './views/system/notice/components/NoticeDialog.vue'
import { getUndoneTaskCount } from '@/api/order/statistics'
import { reexamineBatchExistPartTask } from '@/api/taskProcessing/testVerification'

export default {
  name: 'APP',
  components: {
    NoticeDialog
  },
  data() {
    return {
      timeOutObj: null,
      timeOutObjSide: null,
      getImgCache: null,
      noticeList: []
    }
  },
  computed: {
    token() {
      return this.$store.state.user.token
    },
    userObj() {
      return this.$store.state.user
    },
    strUser() {
      return this.$store.state.user.userData
    }
  },
  watch: {
    userObj: {
      deep: true,
      handler(newVal) {
        // 已经登录完成
        if (newVal && newVal.elements) {
          if (!this.timeOutObj) {
            this.clearTaskTimeout()
            this.initFullTimeOrderReminder()
            this.initSidebarBadgeValue()
            // 获取通知信息(仅在登录后获取一次)
            const noticeFlag = localStorage.getItem('noticeFlag')
            if (!noticeFlag) {
              this.getNoticeMessage()
            }
          }
        }
      }
    }
  },
  created() {
    if (this.token) {
      if (!this.timeOutObj) {
        this.clearTaskTimeout()
        this.initFullTimeOrderReminder()
        this.initSidebarBadgeValue()
      }
    }
    this.getImgCache = setInterval(() => {
      this.initImgCache()
    }, 1000 * 60)
  },
  mounted() {
    window.addEventListener('beforeunload', () => {
      window.clearTimeout(this.timeOutObj)
      window.clearTimeout(this.timeOutObjSide)
      window.clearInterval(this.getImgCache)
    })
  },
  methods: {
    // 初始化图片初始化
    initImgCache() {
      const loadImg = (url) => {
        return new Promise((resolve, reject) => {
          const img = new Image()
          // 可以访问到图片，在一个局域网内走默认的
          img.onload = () => {
            resolve(true)
          }
          // 访问不到图片
          img.onerror = () => {
            resolve(false)
          }
          img.src = url + '/cache/hello'
        })
      }
      const imgList = ['https://hr_local_cdn.ainfinit.com', 'https://hr_local_cdn2.ainfinit.com']
      Promise.all(imgList.map(url => loadImg(url))).then(list => {
        const index = list.findIndex(item => item === true)
        this.$store.dispatch('setUseLocalAreaNetworkCache', imgList[index])
      })
    },

    myNotify(text, url) {
      this.$notify({
        title: '通知信息',
        message: this.$createElement('div', {
          style: {
            'margin-top': '15px'
          }
        }, [
          text,
          this.$createElement('el-button', {
            props: {
              type: 'primary',
              size: 'mini'
            },
            on: {
              click: () => {
                this.$router.push(url)
              }
            },
            style: {
              float: 'right',
              fontSize: '12px',
              color: '#fff',
              backgroundColor: '#1890ff',
              border: 'none',
              padding: '3px 20px',
              'margin-top': '10px',
              borderRadius: '6px',
              transform: 'translateX(30%)'
            }
          }, '去处理')]),
        type: 'warning',
        customClass: 'focus-message'
      })
    },

    // 全职人员的待处理订单提醒
    initFullTimeOrderReminder() {
      const checkAndNotify = () => {
        // 是全职身份且未被暂停接单
        const strUser = typeof this.strUser === 'string' ? JSON.parse(this.strUser) : this.strUser
        const isEligibleUser = strUser.userRole &&
          ['crowdsourceFullUser', 'OuterHandler'].includes(strUser.userRole) &&
          strUser.status !== 2
        if (!isEligibleUser) return
        getUndoneTaskCount().then(res => {
          if (res.status === 200) {
            if (res.data >= 200) {
              this.myNotify('当前待处理订单存在积压，请及时处理！', 'workbench/sse')
            }
          }
        })
      }

      // 本次检查
      checkAndNotify()
      // 设置定期检查
      this.timeOutObj = setTimeout(this.initFullTimeOrderReminder, 10 * 60 * 1000)
    },

    // 设置侧边栏的badge值
    initSidebarBadgeValue(type) {
      this.$nextTick(() => {
        const strUser = typeof this.strUser === 'string' ? JSON.parse(this.strUser) : this.strUser
        // 是否兼职人员
        const isPartUser = ['PartHandler'].includes(strUser.userRole)
        if (isPartUser) {
          reexamineBatchExistPartTask().then(res => {
            const payload = { parentName: '天降财运', childName: '处理任务', count: Number(res.data) }
            this.onSetGlobalState(payload)
          })
        }
        // 每分钟检查一次
        this.timeOutObjSide = setTimeout(this.initSidebarBadgeValue, 60 * 1000)
      })
    },

    onSetGlobalState(payload) {
      this.$store.commit('SET_PERMISSION_MENUS_BADGE', payload)
    },

    clearTaskTimeout() {
      window.clearTimeout(this.timeOutObj)
      window.clearTimeout(this.timeOutObjSide)
      this.timeOutObj = null
      this.timeOutObjSide = null
    },

    /**
     * 获取通知中心消息 每次登录存一次再次刷新不去获取
     */
    getNoticeMessage() {
      this.$store.dispatch('GetNotice', { windowFlag: 1, readFlag: 0 }).then(rows => {
        localStorage.setItem('noticeFlag', true)
        this.noticeList = rows
        this.openDialog()
      })
    },

    openDialog() {
      if (this.noticeList.length > 0) {
        const notice = JSON.parse(JSON.stringify(this.noticeList[0]))
        this.$store.dispatch('MarkMessageRead', notice.msgId)
        this.$refs.noticeDialog.open(notice)
        this.noticeList.shift()
      }
    }
  }
}
</script>

<style lang="scss">
@import "./styles/index.scss"; // 全局自定义的css样式

.el-notification .el-icon-warning {
  color: #ff8040;
}
.el-notification__closeBtn {
  font-size: 30px;
  top: 10px;
  right: 5px;
}
.el-notification__group {
  margin-top: 4px;
}
</style>
